export const GET_GTM_TRIGGERS = "GET_GTM_TRIGGERS";
export const PATCH_GTM_TRIGGERS = "PATCH_GTM_TRIGGERS";